import React from 'react'
import ReactDOM from 'react-dom/client'
import SessionTimeoutHandler from 'components/SessionTimeoutHandler'


const mountPoint = document.getElementById('session-timeout-mountpoint')
const duration = parseInt(mountPoint.getAttribute('data-session-duration'))
const lastAccess = parseInt(mountPoint.getAttribute('data-session-last-access'))

ReactDOM
    .createRoot(mountPoint)
    .render(<SessionTimeoutHandler duration={duration} lastAccess={lastAccess} />)
